export default __webpack_public_path__ + "static/media/acceleY.4b0c76b1.svg";